export const socials = {
    facebook: "https://facebook.com/beohoang1998",
    github: "https://github.com/beohoang98",
    instagram: "https://instagram.com/beohoang98",
    linkedin: "https://linkedin.com/in/an-hoang98",
};
